module.exports = __webpack_public_path__ + "static/assets/cee477fa706ab6fe733a65edd475c41b.svg";